/* eslint-disable import/order */
import Vue from "vue";
import App from "./App.vue";

import Meta from "vue-meta";

Vue.use(Meta);

import "foundation-sites";

// const jQuery           = require('jquery');
// (window as any).jQuery = jQuery;

import nl2br from "@/lib/filters/nl2br.ts";

Vue.filter("nl2br", nl2br);

import { DIContainer } from "./app.container";

import dataStore from "./store";

import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

import * as ModalDialogs from "vue-modal-dialogs";

Vue.use(ModalDialogs);

Vue.config.productionTip = false;

const router = DIContainer.Router;

new Vue({
  router,
  store: dataStore,
  provide: DIContainer,
  render: (h) => h(App),
}).$mount("#app");
